// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b8fe58cc7ed696be1597","655":"e426ddefa851a01a65a4"}[chunkId] + ".js";
};